import { IonPage } from "@ionic/react";
import { useSectionViewTracking } from "@/lib/useSectionViewTracking";
import { Nav } from "@/components/Nav/Nav";
import { Footer } from "@/components/Footer/Footer";
import { Hero } from "@/sections/Hero/Hero";
import { Thesis } from "@/sections/Thesis/Thesis";
import { Proof } from "@/sections/Proof/Proof";
import { WhatWeGoFor } from "@/sections/WhatWeGoFor/WhatWeGoFor";
import { Offerings } from "@/sections/Offerings/Offerings";
import { MissionVision } from "@/sections/MissionVision/MissionVision";
import { Contact } from "@/sections/Contact/Contact";
import styles from "./Home.module.scss";

export const Home = () => {
  useSectionViewTracking();

  return (
  <IonPage>
    <div className={styles.page}>
      <Nav />
      <main className={styles.main}>
        <Hero />
        <Thesis />
        <Proof />
        <WhatWeGoFor />
        <Offerings />
        <MissionVision />
        <Contact />
      </main>
      <Footer />
    </div>
  </IonPage>
  );
};
